import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertMediaUI from './insertmediaui';


export default class InsertMedia extends Plugin {
  static get pluginName() {
    return 'InsertMedia';
  }

  static get requires() {
    return [ InsertMediaUI];
  }
}
